import React from 'react';
import { Link } from 'react-router-dom';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';

export default function TermosCondicoes() {
  return (
    <div className="min-h-screen bg-gestao-background text-slate-800">
      <SiteHeader />
      <main className="pt-24 pb-16 px-4 sm:px-6">
        <div className="max-w-3xl mx-auto prose prose-slate prose-headings:text-gestao-primary">
          <h1 className="text-3xl font-bold mb-8">Termos e Condições</h1>
          <p className="text-slate-600 text-sm mb-8">
            Última atualização: {new Date().toLocaleDateString('pt-PT')}
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">1. Identificação</h2>
            <p>
              O presente website é propriedade da <strong>Electro Salir Lda.</strong>, pessoa coletiva com sede em Rua Manuel Dourado Eusébio N.º 34 A, Salir, 8100-202 Portugal, NIF 502 529 962.
            </p>
            <p className="mt-2">
              Para contactar a Electro Salir Lda.: telefone 289 489 848, telemóvel 917 869 307, e-mail electrosalir@sapo.pt.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">2. Objeto</h2>
            <p>
              Estes Termos e Condições regulam o acesso e a utilização do website da Electro Salir Lda. e a relação entre a Electro Salir Lda. e os utilizadores que o visitam. A utilização do site implica a aceitação integral dos presentes termos.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">3. Serviços</h2>
            <p>
              A Electro Salir Lda. dedica-se à prestação de serviços de climatização, instalação e manutenção de ar condicionado, painéis solares térmicos e fotovoltaicos, e assistência técnica relacionada. As condições específicas de cada serviço ou orçamento serão acordadas com o cliente em momento próprio.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">4. Utilização do site</h2>
            <p>
              O utilizador compromete-se a utilizar o site de forma legal e respeitando os direitos de terceiros. É proibida a utilização para fins ilícitos ou que possam prejudicar o bom nome da Electro Salir Lda. ou de terceiros.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">5. Propriedade intelectual</h2>
            <p>
              Os conteúdos do site (textos, imagens, logotipos, grafismos) são propriedade da Electro Salir Lda. ou de titulares que autorizaram a sua utilização. A reprodução ou utilização não autorizada pode constituir violação de direitos de autor ou outros direitos de propriedade intelectual.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">6. Limitação de responsabilidade</h2>
            <p>
              A Electro Salir Lda. esforça-se por manter as informações do site corretas e atualizadas, mas não garante a ausência de erros ou interrupções. A Electro Salir Lda. não será responsável por danos indiretos ou consequentes resultantes da utilização ou impossibilidade de utilização do site.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">7. Links para outros sites</h2>
            <p>
              O site pode conter ligações para sites de terceiros. A Electro Salir Lda. não controla nem se responsabiliza pelo conteúdo ou práticas de sites externos.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">8. Lei aplicável e foro</h2>
            <p>
              Os presentes Termos e Condições são regidos pela lei portuguesa. Qualquer litígio será submetido aos tribunais da comarca de Loulé, com exclusão de qualquer outro.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mt-8 mb-4">9. Contactos</h2>
            <p>
              Para questões relativas a estes Termos e Condições, contacte a Electro Salir Lda. (NIF 502 529 962): Rua Manuel Dourado Eusébio N.º 34 A, Salir, 8100-202 Portugal; tel. 289 489 848; tlm. 917 869 307; e-mail electrosalir@sapo.pt.
            </p>
          </section>

          <p className="mt-12">
            <Link to="/" className="text-gestao-primary font-semibold hover:underline">
              ← Voltar ao início
            </Link>
          </p>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
